import { useTranslation } from 'react-i18next';

import { MainSegment } from 'api/responses/models/Unit/UnitStructure/MainSegment';
import { useDetailedSegments } from 'domain/detailSegment/useDetailedSegments';
import { DetailedSegment } from 'domain/unit/enums/DetailedSegment';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';

export type DetailedSegmentDisplayProps = {
	mainSegment: MainSegment | null;
	detailedSegment: DetailedSegment | null;
};

export const DetailedSegmentDisplay = ({
	mainSegment,
	detailedSegment,
}: DetailedSegmentDisplayProps): React.JSX.Element => {
	const { t } = useTranslation('commonUnit');
	const { data } = useDetailedSegments(mainSegment);

	const detailedSegmentStr = data?.find(
		(li) => li.value === detailedSegment?.toString()
	)?.text;

	return (
		<TextDisplay label={t('detailed-segment')} value={detailedSegmentStr} />
	);
};
